import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ArrowDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ArrowDownIcon = ({ className, ...props }: ArrowDownIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.25 5.5V18M12.25 18L6.25 12M12.25 18L18.25 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default ArrowDownIcon;
